export const environment = {
    production: true,
    host: 'https://api.skedflex.dev/api'
};
